import { t } from './localization';

export const TEAMS_NAMES = {
  1: t('Альфа'),
  2: t('Браво'),
};
